const setNumberOfPresentationPagesAction = ({ commit }, payload) => {
  commit('setNumberOfPresentationPages', payload)
}

const setNumberOfLoadedPresentationPagesAction = ({ commit }, payload) => {
  commit('setNumberOfLoadedPresentationPages', payload)
}

export default {
  setNumberOfPresentationPagesAction,
  setNumberOfLoadedPresentationPagesAction,
}
